// Input atom component
export const Input = ({
  type = "text",
  placeholder,
  value,
  onChange,
  className = "",
  ...props
}) => {
  const baseStyles =
    "w-full px-5 py-3 bg-white border border-terracotta-200 rounded-xl text-ink placeholder:text-ink-soft/50 focus:outline-none focus:border-terracotta-400 focus:ring-2 focus:ring-terracotta-100 transition";

  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={`${baseStyles} ${className}`}
      {...props}
    />
  );
};
